import styles from './primeiroAdquirenteComponentesBaseDeCalculo.module.scss';
import {
  IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao,
  ICodigoNcm as ICodigoNcmBaseCalculo,
} from '../../../../interfaces/IBaseDeCalculo';
import { ICodigoNcm } from '../../../../interfaces/ICodigoNcm';
import PrimeiroAdquirenteComponentesBaseDeCalculoFormPorDoc from './components/baseDeCalculoFormPorDoc/baseDeCalculoFormPorDoc';
import NotaFiscalList from '../../../../components/notaFiscalList/notaFiscalList';
import ComponentesBaseDeCalculoFormItemNCM from '../../../../components/baseDeCalculoFormItemNCM/baseDeCalculoFormItemNCM';

interface IPrimeiroAdquirenteComponentesBaseDeCalculoProps {
  option: string;
  listaComponentesBaseCalculo: IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao[];
  setListaComponentesBaseCalculo: React.Dispatch<
    React.SetStateAction<IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao[]>
  >;
  listaCodigosNCM: ICodigoNcmBaseCalculo[];
  setListaCodigosNCM: React.Dispatch<React.SetStateAction<ICodigoNcmBaseCalculo[]>>;
  codigosNCM: ICodigoNcm[];
  numeroProcesso: string;
}

function PrimeiroAdquirenteComponentesBaseDeCalculo({
  option,
  listaComponentesBaseCalculo,
  setListaComponentesBaseCalculo,
  listaCodigosNCM,
  setListaCodigosNCM,
  codigosNCM,
  numeroProcesso,
}: IPrimeiroAdquirenteComponentesBaseDeCalculoProps) {
  return (
    <>
      {option === 'documentoFiscal' ? (
        <>
          <div className={styles.container}>
            <PrimeiroAdquirenteComponentesBaseDeCalculoFormPorDoc
              listaComponentesBaseCalculo={listaComponentesBaseCalculo}
              setListaComponentesBaseCalculo={setListaComponentesBaseCalculo}
              listaCodigosNCM={listaCodigosNCM}
              setListaCodigosNCM={setListaCodigosNCM}
              codigosNCM={codigosNCM}
              numeroProcesso={numeroProcesso}
            />
          </div>
          <NotaFiscalList
            componentesBaseCalculo={listaComponentesBaseCalculo}
            setListaComponentesBaseCalculo={setListaComponentesBaseCalculo}
          />
        </>
      ) : (
        <div className={styles.container}>
          <ComponentesBaseDeCalculoFormItemNCM
            listaComponentesBaseCalculo={listaComponentesBaseCalculo}
            setListaComponentesBaseCalculo={setListaComponentesBaseCalculo}
            listaCodigosNCM={listaCodigosNCM}
            setListaCodigosNCM={setListaCodigosNCM}
            codigosNCM={codigosNCM}
            type='Aquisição'
            isConsolidado
            numeroProcesso={numeroProcesso}
          />
        </div>
      )}
    </>
  );
}

export default PrimeiroAdquirenteComponentesBaseDeCalculo;
